import React from 'react';
import { Col, Grid, Section } from '@fiverr-private/fit';
import AssetsGallery from '../AssetsGallery';
import OverviewCard from '../OverviewCard';
import Footer from '../Footer';
import Title from '../Title';
import style from './style.module.scss';

const AssetsPageComponent = () => (
    <div>
        <Section>
            <Grid className={style.body}>
                <Col sm={10} md={8}>
                    <Title />
                    <div className={style.border}>
                        <div className={style.galleryContainer}>
                            <AssetsGallery />
                        </div>
                        <OverviewCard />
                    </div>
                </Col>
            </Grid>
        </Section>
        <div className={style.footerContainer}>
            <Footer />
        </div>
    </div>
);

export default AssetsPageComponent;
